import React from 'react'
import './style.css'
import {Container, Tabs, Tab} from 'react-bootstrap'
import CompLinkHeader from 'components/riwayat/compLinkHeader'
import Bayar from './components/bayar'
import Proses from './components/proses'
import Kirim from './components/kirim'
import Selesai from './components/selesai'
import Batal from './components/batal'

export default function Index() {

    return (
        <Container className="page-transaksi-component">
            <CompLinkHeader to="/profile" back="Transaksi" title="Transaksi Malmora" />
            <div className="content-transaksi">
                <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
                    {
                        Data.map((data, i) => {
                            return (
                                <Tab key={i} eventKey={data.link} title={data.title}>
                                        {i === 0 ? <Bayar /> :null}         
                                        {i === 1 ? <Proses /> :null}         
                                        {i === 2 ? <Kirim /> :null}         
                                        {i === 3 ? <Selesai /> :null}         
                                        {i === 4 ? <Batal /> :null}         
                                </Tab>
                            )
                        })
                    }
                </Tabs>
            </div>
        </Container>
    )
}

const Data = [
    {link:"bayar", title:"Belum Dibayar"},{link:"proses", title:"Diproses"},{link:"kirim", title:"Dikirim"},{link:"selesai", title:"Selesai"},{link:"batal", title:"Dibatalkan"},{link:"kembali", title:"Pengembalian"}
]
